<div name="controlform" class="control-form aspNetControlId-{{item.aspNetControlId}}" id="controlform{{item.genID}}">
  @if(item.aspNetControlId !== ASPNetControl.Repeating_Section && item.aspNetControlId !==ASPNetControl.Hidden)
  {
  <div class="control-form-section" id="control-form-section{{item.genID}}"
       [class.epaylabel]="item.aspNetControlId !== ASPNetControl.Label">
    @if(item.aspNetControlId === ASPNetControl.Label)
    {
    <span [class.hidden]="item.visible==false"
          [innerHTML]="sanitize((item.defaultValue ? item.defaultValue:item.screenValue))"
          id="lbl{{item.genID}}" class="screen-value">
    </span>
    }
    @if(item.aspNetControlId !== ASPNetControl.Label && item.aspNetControlId !== ASPNetControl.New_Line && hasValue(item.screenValue)
    && item.aspNetControlId !== ASPNetControl.RadioButtonList && item.aspNetControlId !== ASPNetControl.CheckBoxList)
    {
    <label [class.hidden]="item.visible==false" [innerHTML]="sanitize(item.screenValue)"
           id="lbl{{item.genID}}" class="screen-value"
           for="{{controlName(item)}}"
           attr.aria-label="{{AriaLabel(item.screenValue)}}">
    </label>
    }
    @if(item.typeId === TypeInfo.None ||
    item.typeId === TypeInfo.Email_Address ||
    item.typeId === TypeInfo.URL ||
    item.typeId === TypeInfo.Phone_Number ||
    item.typeId === TypeInfo.Zip_Code)
    {
    <span id="formulate{{item.genID}}"
          [class.hidden]="item.visible==false"
          class="Formula">
    </span>
    }
    @if(item.typeId === TypeInfo.Number && item.aspNetControlId === ASPNetControl.Label)
    {
    <span id="formulate{{item.genID}}"
          [class.hidden]="item.visible==false"
          class="Formula">
      {{ToNumber(item.formulaEval) | number}}
    </span>
    }
    @if(item.typeId === TypeInfo.Whole_Number && item.aspNetControlId === ASPNetControl.Label)
    {
    <span id="formulate{{item.genID}}"
          [class.hidden]="item.visible==false"
          class="Formula">
      {{ToNumber(item.formulaEval) | number:'2'}}
    </span>
    }
    @if(item.typeId === TypeInfo.Currency && item.aspNetControlId === ASPNetControl.Label)
    {
    <span id="formulate{{item.genID}}"
          [class.hidden]="item.visible==false"
          class="Formula">
      {{ToNumber(item.formulaEval) | currency}}
    </span>
    }
    @if(item.typeId === TypeInfo.Number_As_Currency && item.aspNetControlId === ASPNetControl.Label)
    {
    <span id="formulate{{item.genID}}"
          [class.hidden]="item.visible==false"
          class="Formula">
      {{ToNumber(item.formulaEval) | currency}}
    </span>
    }
    @if(item.typeId === TypeInfo.Required_Amount && item.aspNetControlId === ASPNetControl.Label)
    {
    <span id="formulate{{item.genID}}"
          [class.hidden]="item.visible==false"
          class="Formula">
      {{ToNumber(item.formulaEval) | currency}}
    </span>
    }
    @if(item.typeId === TypeInfo.Date && item.aspNetControlId === ASPNetControl.Label)
    {
    <span id="formulate{{item.genID}}"
          [class.hidden]="item.visible==false"
          class="Formula">
      {{ToDate(item.formulaEval) | date:'shortDate'}}
    </span>
    }
    @if(!item.valid && item.aspNetControlId !== ASPNetControl.RadioButtonList && item.aspNetControlId && hasValue(item.screenValue)
    && item.aspNetControlId !== ASPNetControl.CheckBoxList
    )
    {
    <span id="validator{{item.genID}}"
          class="text-danger require-field-validator ">*</span>
    }
    <div class="error-message">
      {{errorMessages()}}
    </div>
  </div>
  }
  @if(item.aspNetControlId !== ASPNetControl.Label)
  {
  <div class="epaycontrol" id="epaycontrol{{item.genID}}"
       [class.dropdownlistwrap]="item.aspNetControlId === ASPNetControl.DropDownList">
    @if(item.aspNetControlId === ASPNetControl.TextBox)
    {
    <span class="table-cell epaycontrol-textbox"
          id="control{{item.genID}}">
      @if(item.typeId === TypeInfo.None && item.size <= 50)
      {
      <input type="text"
             class="form-control mb15 input-textbox"
             [class.hidden]="item.visible==false"
             [(ngModel)]="item.value"
             [required]="item.required"
             [style.width.px]="width(item.size)"
             name="txtBoxName{{item.genID}}"
             id="txtBoxId{{item.genID}}"
             [disabled]="!item.enabled" />
      }
      @if(item.typeId === TypeInfo.None && item.size > 50)
      {
      <textarea type="text"
                class="form-control mb15 input-textbox"
                [class.hidden]="item.visible==false"
                [(ngModel)]="item.value"
                [required]="item.required"
                name="txtBoxName{{item.genID}}"
                id="txtBoxId{{item.genID}}"
                [disabled]="!item.enabled"></textarea>
      }
      @if(item.typeId === TypeInfo.Phone_Number)
      {
      <kendo-maskedtextbox [mask]="telephoneMask"
                           [class.hidden]="item.visible==false"
                           [value]="ToString(item.value)"
                           (valueChange)="item.value = $event.trim()"
                           [style.width.px]="width(item.size)"
                           [disabled]="!item.enabled"
                           class="input-phonenumber"
                           id="txtBoxId{{item.genID}}"
                           required="required"
                           #kendoMaskedTextbox>
      </kendo-maskedtextbox>
      }
      @if(item.typeId === TypeInfo.Phone_Number)
      {
      <input type="text"
             class="form-control input-textbox"
             [class.hidden]="item.visible==false"
             [(ngModel)]="item.value"
             [required]="item.required"
             [style.width.px]="width(item.size)"
             name="txtBoxName{{item.genID}}"
             id="txtBoxId{{item.genID}}"
             #inputMaskedTextbox
             style="display:none"
             [disabled]="!item.enabled" />
      }
      @if(item.typeId === TypeInfo.Email_Address)
      {
      <input type="email"
             [email]="!(item.value===''||!item.value)"
             [class.hidden]="item.visible==false"
             [style.width.px]="width(item.size)"
             [required]="item.required"
             [disabled]="!item.enabled"
             name="txtBoxName{{item.genID}}"
             id="txtBoxId{{item.genID}}"
             class="form-control input-emailaddress"
             [(ngModel)]="item.value" />
      }
      @if(item.typeId === TypeInfo.Date)
      {
      <kendo-dateinput [class.hidden]="item.visible==false"
                       [(ngModel)]="value"
                       [disabled]="!item.enabled"
                       name="txtBoxName{{item.genID}}"
                       id="txtBoxId{{item.genID}}"
                       class="form-control input-date"
                       [required]="item.required"
                       >
      </kendo-dateinput>
      }
      @if(item.typeId === TypeInfo.Number)
      {
      <kendo-numerictextbox [class.hidden]="item.visible==false"
                            [style.width]="'auto'"
                            [spinners]="false"
                            [ngModel]="ParseDec(item.value)"
                            (ngModelChange)="item.value = $event"
                            [required]="item.required"
                            [format]="'#.######'"
                            [disabled]="!item.enabled"
                            name="txtBoxName{{item.genID}}"
                            id="txtBoxId{{item.genID}}"
                            class="form-control input-number"
                            [autoCorrect]="false">
      </kendo-numerictextbox>
      }
      @if(item.typeId === TypeInfo.Currency)
      {
      <kendo-numerictextbox [class.hidden]="item.visible==false"
                            [style.width]="'auto'"
                            [spinners]="false"
                            [ngModel]="ParseDec(item.value)"
                            (ngModelChange)="item.value = $event"
                            [required]="item.required"
                            [format]="'c2'"
                            [min]="0"
                            [disabled]="!item.enabled"
                            name="txtBoxName{{item.genID}}"
                            id="txtBoxId{{item.genID}}"
                            class="form-control input-currency"
                            [autoCorrect]="false">
      </kendo-numerictextbox>
      }
      @if(item.typeId === TypeInfo.Zip_Code)
      {
      <kendo-maskedtextbox [mask]="zipcodeMask"
                           [class.hidden]="item.visible==false"
                           [value]="item.value?.toString()"
                           (valueChange)="item.value = $event.trim()"
                           [style.width.px]="width(item.size)"
                           [disabled]="!item.enabled"
                           class="form-control input-zipcode"
                           id="txtBoxId{{item.genID}}"
                           required="required"
                           #kendoMaskedTextbox>
      </kendo-maskedtextbox>
      }
      @if(item.typeId === TypeInfo.Zip_Code)
      {
      <input type="text"
             [class.hidden]="item.visible==false"
             class="form-control mb15 input-textbox"
             [(ngModel)]="item.value"
             [required]="item.required"
             [style.width.px]="width(item.size)"
             name="txtBoxName{{item.genID}}"
             id="txtBoxId{{item.genID}}"
             #inputMaskedTextbox
             style="display:none"
             [disabled]="!item.enabled" />
      }
      @if(item.typeId === TypeInfo.Number_As_Currency)
      {
      <kendo-numerictextbox [class.hidden]="item.visible==false"
                            [style.width]="'auto'"
                            [spinners]="false"
                            [ngModel]="ParseDec(item.value)"
                            (ngModelChange)="item.value = $event"
                            [required]="item.required"
                            [format]="'n2'"
                            [min]="0.01"
                            [disabled]="!item.enabled"
                            name="txtBoxName{{item.genID}}"
                            id="txtBoxId{{item.genID}}"
                            class="form-control input-currency-number"
                            [autoCorrect]="true">
      </kendo-numerictextbox>
      }
    </span>
    }
    @if(item.aspNetControlId === ASPNetControl.DropDownList)
    {
    <span class="kendoDropList">
      <span class="kendoDrop">
        <select class="styled-dropdown" [required]="item.required && !item.value"
                [ngModel]="item.value"
                (click)="selectItem(item, $event)"
                (change)="selectItem(item, $event)"
                [class.hidden]="item.visible==false" name="ddlName{{item.genID}}" id="ddlId{{item.genID}}">
          @if(!item.required)
          {
          <option value="" [disabled]="item.required" class="PlaceHolderPageText">
          </option>
          }
          @for(sitem of item.preQuestionItem; track sitem.genID)
          {
          <option [value]="sitem.genID"
                  [innerHTML]="sitem.screenValue" class="input-dropdown-screenvalue">
          </option>
          }
        </select>
      </span>
    </span>
    }
    @if(item.aspNetControlId === ASPNetControl.CheckBoxList)
    {
    @if(item.preQuestionItem.length > 1 || hasValue(item.screenValue))
    {
    <fieldset>
      <legend [class.hidden]="item.visible==false" [innerHTML]="sanitize(item.screenValue)"
              id="lbl{{item.genID}}" class="screen-value checkboxlist_label"
              [class.ng-invalid]="!item.valid"
              attr.aria-label="{{AriaLabel(item.screenValue)}}">
      </legend>

      <span class="checkboxlist">
        @for(child of item.preQuestionItem; track child.genID)
        {
        <span class="checkboxlistitem">
          <input type="checkbox"
                 [disabled]="!item.enabled"
                 [(ngModel)]="child.value"
                 name="chkBoxName{{child.genID}}"
                 id="chkBoxId{{item.genID}}">
          <label [innerHTML]="child.screenValue" class="input-checkbox-screenvalue checkboxlistitem_label"
                 for="chkBoxId{{item.genID}}">
          </label>
        </span>
        }
      </span>
    </fieldset>
    }
    @else
    {
    <span class="checkboxlist">
      @for(child of item.preQuestionItem; track child.genID)
      {
      <span class="checkboxlistitem" [class.ng-invalid]="!item.valid">
        <input type="checkbox"
               [disabled]="!item.enabled"
               [(ngModel)]="child.value"
               name="chkBoxName{{child.genID}}"
               id="chkBoxId{{item.genID}}">
        <label [innerHTML]="child.screenValue" class="input-checkbox-screenvalue checkboxlist_label"
               for="chkBoxId{{item.genID}}">
        </label>
      </span>
      }
    </span>
    }
    }
    @if(item.aspNetControlId === ASPNetControl.RadioButtonList)
    {

    @if(item.preQuestionItem.length > 1 || hasValue(item.screenValue))
    {
    <fieldset [class.ng-invalid]="!item.valid && !hasValue(item.screenValue)">
      @if(hasValue(item.screenValue))
      {
      <legend [class.hidden]="item.visible==false"
              [innerHTML]="sanitize((item.defaultValue ? item.defaultValue:item.screenValue))"
              attr.aria-label="{{AriaLabel(item.defaultValue ? item.defaultValue:item.screenValue)}}"
              [class.ng-invalid]="!item.valid"
              id="lbl{{item.genID}}" class="screen-value">
      </legend>
      }
      @for(child of item.preQuestionItem; track child.genID)
      {
      <span class="radiolistitem">
        @if(!item.enabled)
        {
        <input type="radio" id="radioId{{child.genID}}" class="radiobutton" style="display:none"
               name="radioName{{item.genID}}"
               [checked]="isRadioButtonItemSelected(item.value, child.genID)"
               onclick="return false;"
               (click)="item.value = item.value.toString();">
        <span class="checkmark radiobutton" [class.checked]="isRadioButtonItemSelected(item.value, child.genID)"></span>
        <label [innerHTML]="child.screenValue" class="radiobutton-label" for="radioId{{child.genID}}"></label>
        }
        @if(item.enabled)
        {
        <input type="radio" id="radioId{{child.genID}}" class="table-cell"
               name="radioName{{item.genID}}"
               [checked]="isRadioButtonItemSelected(item.value, child.genID)"
               (click)="item.value = child.genID.toString()">
        <span [class.ng-invalid]="!item.valid && item.preQuestionItem.length == 1"
              [class.radiolist-invalid]="!item.valid && item.preQuestionItem.length == 1">
          <label [innerHTML]="child.screenValue" class="table-cell" for="radioId{{child.genID}}"></label>
        </span>
        }
      </span>

      @if(!hasValue(item.screenValue))
      {
      <span id="validator{{item.genID}}"
            class="text-danger require-field-validator ">*</span>
      }
      }
    </fieldset>
    }
    @else
    {
    @for(child of item.preQuestionItem; track child.genID)
    {
    <span class="radiolistitem">
      @if(!item.enabled)
      {
      <input type="radio" id="radioId{{child.genID}}" class="radiobutton" style="display:none"
             name="radioName{{item.genID}}"
             [checked]="isRadioButtonItemSelected(item.value, child.genID)"
             onclick="return false;"
             (click)="item.value = item.value.toString();">
      <span class="checkmark radiobutton" [class.checked]="isRadioButtonItemSelected(item.value, child.genID)"></span>
      <label [innerHTML]="child.screenValue" class="radiobutton-label" for="radioId{{child.genID}}"></label>
      }
      @if(item.enabled)
      {
      <input type="radio" id="radioId{{child.genID}}" class="table-cell"
             name="radioName{{item.genID}}"
             [checked]="isRadioButtonItemSelected(item.value, child.genID)"
             (click)="item.value = child.genID.toString()">
      <span [class.ng-invalid]="!item.valid && item.preQuestionItem.length == 1"
            [class.radiolist-invalid]="!item.valid && item.preQuestionItem.length == 1"
            class="radiolistSingleItem">
        <label [innerHTML]="child.screenValue" class="table-cell" for="radioId{{child.genID}}"></label>
      </span>
      }
    </span>
    <span id="validator{{item.genID}}"
          class="text-danger require-field-validator ">*</span>
    }
    }
    }
    @if(item.aspNetControlId === ASPNetControl.New_Line)
    {
    <span>
      <br />
    </span>
    }
    @if(item.aspNetControlId === ASPNetControl.User_Defined_Amount)
    {
    <span>
      @if(item.typeId === TypeInfo.Required_Amount)
      {
      <kendo-numerictextbox [spinners]="false"
                            [style.width]="'auto'"
                            [class.hidden]="item.visible==false"
                            [ngModel]="ParseDec(item.value)"
                            (ngModelChange)="item.value = $event"
                            [required]="item.required"
                            [format]="'c2'"
                            [min]="0.01"
                            [disabled]="!item.enabled"
                            name="udaName{{item.genID}}"
                            id="udaId{{item.genID}}"
                            [autoCorrect]="false"
                            class="input-userdefined-amount">
      </kendo-numerictextbox>
      }
      @if(item.typeId === TypeInfo.None)
      {
      <kendo-numerictextbox [spinners]="false"
                            [style.width]="'auto'"
                            [class.hidden]="item.visible==false"
                            [ngModel]="ParseDec(item.value)"
                            (ngModelChange)="item.value = $event"
                            [required]="item.required"
                            [format]="'c2'"
                            [disabled]="!item.enabled"
                            name="udaName{{item.genID}}"
                            id="udaId{{item.genID}}"
                            [autoCorrect]="false"
                            class="input-userdefined-amount">
      </kendo-numerictextbox>
      }
      @if(item.typeId === TypeInfo.Number)
      {
      <kendo-numerictextbox [spinners]="false"
                            [style.width]="'auto'"
                            [class.hidden]="item.visible==false"
                            [ngModel]="ParseDec(item.value)"
                            (ngModelChange)="item.value = $event"
                            [required]="item.required"
                            [format]="'c2'"
                            [disabled]="!item.enabled"
                            name="udaName{{item.genID}}"
                            id="udaId{{item.genID}}"
                            [autoCorrect]="false"
                            class="input-userdefined-amount">
      </kendo-numerictextbox>
      }
      @if(item.typeId === TypeInfo.Currency)
      {
      <kendo-numerictextbox [spinners]="false"
                            [style.width]="'auto'"
                            [class.hidden]="item.visible==false"
                            [ngModel]="ParseDec(item.value)"
                            (ngModelChange)="item.value = $event"
                            [required]="item.required"
                            [format]="'c2'"
                            [disabled]="!item.enabled"
                            name="udaName{{item.genID}}"
                            id="udaId{{item.genID}}"
                            [autoCorrect]="false"
                            class="input-userdefined-amount">
      </kendo-numerictextbox>
      }
      @if(item.typeId === TypeInfo.Number_As_Currency)
      {
      <kendo-numerictextbox [spinners]="false"
                            [style.width]="'auto'"
                            [class.hidden]="item.visible==false"
                            [ngModel]="ParseDec(item.value)"
                            (ngModelChange)="item.value = $event"
                            [required]="item.required"
                            [format]="'c2'"
                            [disabled]="!item.enabled"
                            name="udaName{{item.genID}}"
                            id="udaId{{item.genID}}"
                            [autoCorrect]="false"
                            class="input-userdefined-amount">
      </kendo-numerictextbox>
      }
      @if(item.typeId === TypeInfo.Whole_Number)
      {
      <kendo-numerictextbox [spinners]="false"
                            [style.width]="'auto'"
                            [class.hidden]="item.visible==false"
                            [ngModel]="ParseDec(item.value)"
                            (ngModelChange)="item.value = $event"
                            [required]="item.required"
                            [format]="'c0'"
                            [disabled]="!item.enabled"
                            name="udaName{{item.genID}}"
                            id="udaId{{item.genID}}"
                            [autoCorrect]="false"
                            class="input-userdefined-amount">
      </kendo-numerictextbox>
      }
    </span>
    }
    @if(item.aspNetControlId === ASPNetControl.Ordered_List)
    {
    <span>
      @for(item of orderList; let i = $index; track i)
      {
      <span class="orderedList">
        <span>
          <span>{{i + 1}}. </span><input id="orderlistitem_{{i}}" name="orderlistitem_{{i}}" type="text"
                                         [(ngModel)]="orderList[i]" (ngModelChange)="checkOrderList()" />
        </span>
      </span>
      }
    </span>
    }
    @if(item.aspNetControlId === ASPNetControl.States_List)
    {
    <span class="states">
      <states [(state)]="item.value"></states>
    </span>
    }
  </div>
  }
</div>
